import {
	GET_ADMIN_PRODUCT_SUCCESS,
	GET_ADMIN_PRODUCT_FAILURE,
	SET_ALERT,
	ADD_PRODUCT_SUCCESS,
	ADD_PRODUCT_FAIL,
	FETCH_PRODUCT_BY_ID,
	FAIL_FETCH_PRODUCT_BY_ID,
	CLEAR_OLD_FETCH_SUCCESS,
	CLEAR_OLD_FETCH_FAIL,
} from '../actions/index';

const initialState = {
	products: null,
	loading: true,
	product: null,
	productLoading: true,
	error: null,
	count: null,
};

const productReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_ADMIN_PRODUCT_SUCCESS:
			return {
				...state,
				products: action.payload.products,
				loading: false,
				error: null,
				count: action.payload.count,
			};
		case ADD_PRODUCT_SUCCESS:
			if (state.products != null) {
				return {
					...state,
					products: [...state.products, action.payload],
					loading: false,
					error: null,
					count: state.count + 1,
				};
			} else {
				return {
					...state,
					products: action.payload,
					loading: false,
					error: null,
					count: 1,
				};
			}
		case FETCH_PRODUCT_BY_ID:
			return {
				...state,
				product: action.payload,
				productLoading: false,
				error: null,
				count: null,
			};
		case GET_ADMIN_PRODUCT_FAILURE:
			return {
				...state,
				products: null,
				loading: false,
				error: action.payload,
				count: null,
			};
		case CLEAR_OLD_FETCH_SUCCESS:
			return {
				...state,
				product: null,
				productLoading: true,
			};
		case CLEAR_OLD_FETCH_FAIL:
			return state;

		default:
			return state;
	}
};

export default productReducer;
